<template>
  <Toaster class="text-left" ref="toaster" />
  <router-view/>
</template>

<script>
import Toaster from "@/components/Toaster";

export default {
  name: 'App',
  components: { Toaster },
  provide() {
    const app = this;
    return {
      showToast(toast) {
        app.$refs.toaster.showToast(toast);
      }
    }
  }
}
</script>
